var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEllipse = function SvgEllipse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 371,
    height: 385,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F2F0FF",
    strokeWidth: 4,
    d: "M513.099 257.012c0 140.67-114.34 254.714-255.396 254.714-141.057 0-255.396-114.044-255.396-254.714 0-140.669 114.339-254.713 255.396-254.713s255.396 114.044 255.396 254.713Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F2F0FF",
    strokeWidth: 4,
    d: "M467.969 256.248c0 118.339-96.189 214.28-214.856 214.28-118.666 0-214.855-95.941-214.855-214.28s96.189-214.28 214.855-214.28c118.667 0 214.856 95.941 214.856 214.28Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F2F0FF",
    strokeWidth: 4,
    d: "M428.193 257.018c0 98.118-79.583 177.661-177.757 177.661-98.173 0-177.756-79.543-177.756-177.661 0-98.119 79.583-177.662 177.756-177.662 98.174 0 177.757 79.543 177.757 177.662Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F2F0FF",
    strokeWidth: 4,
    d: "M393.77 257.008c0 78.733-63.997 142.568-142.953 142.568s-142.953-63.835-142.953-142.568 63.997-142.569 142.953-142.569S393.77 178.274 393.77 257.008Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F2F0FF",
    strokeWidth: 4,
    d: "M353.232 257.015c0 58.931-47.901 106.712-107.001 106.712s-107.002-47.781-107.002-106.712 47.902-106.712 107.002-106.712 107.001 47.781 107.001 106.712Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F2F0FF",
    strokeWidth: 4,
    d: "M325.695 257.011c0 43.762-35.572 79.248-79.464 79.248s-79.464-35.486-79.464-79.248 35.572-79.248 79.464-79.248 79.464 35.485 79.464 79.248Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F2F0FF",
    strokeWidth: 4,
    d: "M286.682 257.013c0 24.382-19.818 44.155-44.277 44.155s-44.278-19.773-44.278-44.155c0-24.381 19.819-44.155 44.278-44.155s44.277 19.774 44.277 44.155Z"
  })));
};
export default SvgEllipse;